import { createProjectsWithAIResponseSchema } from "@mg/schemas/src/christo/projects";

import { API_URL } from "../config/env";
import { smartFetch } from "../utils/http";

// Legacy my-network endpoints were removed from christo (Mar 2026).
// These stubs prevent 404 spam until the frontend pages are fully removed.

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export async function getDesigner(
  _id: string,
  _queries?: (string | number)[],
): Promise<Record<string, any> | null> {
  return null;
}

export async function updateTags(_payload: {
  tags: string[];
  portfolioId: string;
}) {
  return null;
}

export function getTags() {
  return Promise.resolve([]);
}

export async function aiParseImage(key: string) {
  // dev/users/{userId}/{filename}
  const json = await smartFetch(`${API_URL}/private/projects/ai`, {
    method: "POST",
    body: JSON.stringify([
      {
        assets: [
          {
            type: "image",
            source: key,
          },
        ],
      },
    ]),
  });

  const parsedData = createProjectsWithAIResponseSchema.parse(json);
  return parsedData;
}

export async function shareProfile(_args: {
  objectId: string;
  payload: Record<string, unknown>;
}) {
  return undefined;
}
